import { render, staticRenderFns } from "./PaymentTemplate.vue?vue&type=template&id=047e4367"
import script from "./PaymentTemplate.vue?vue&type=script&lang=js"
export * from "./PaymentTemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports